import React, { useEffect } from 'react'
import {
  SupplierUpdateApiError,
  PersonHolderFieldsInput,
  BankAccountInput,
  GeneralFieldsInput,
} from 'EstraSuppliers'
import { useFormikContext } from 'formik'
import { ProfileFormValues } from '../../utils'

interface Props {
  apiError: SupplierUpdateApiError
}

export const ErrorHandler: React.FC<Props> = ({ apiError }) => {
  const { setFieldError } = useFormikContext<ProfileFormValues>()
  const apiErrorData = apiError && apiError.data

  useEffect(() => {
    if (!apiErrorData) {
      return
    }

    // Errors for general fields
    if (apiErrorData.supplier) {
      Object.keys(apiErrorData.supplier).forEach((key: unknown) => {
        const supplierKey = key as keyof GeneralFieldsInput
        const errorMessage =
          apiErrorData &&
          apiErrorData.supplier &&
          apiErrorData.supplier[supplierKey]
        const flattedMessage = [...(errorMessage || [])].join(' - ')
        setFieldError(supplierKey, flattedMessage)
      })
    }

    // Errors for holder
    if (apiErrorData.holder_address) {
      Object.keys(apiErrorData.holder_address).forEach((key: unknown) => {
        const holderKey = key as keyof PersonHolderFieldsInput
        const errorMessage =
          apiErrorData &&
          apiErrorData.holder_address &&
          apiErrorData.holder_address[holderKey]
        const flattedMessage = [...(errorMessage || [])].join(' - ')
        setFieldError(`holder_address.${holderKey}`, flattedMessage)
      })
    }

    // Errors for technical director
    if (apiErrorData.technical_director_address) {
      Object.keys(apiErrorData.technical_director_address).forEach(
        (key: unknown) => {
          const holderKey = key as keyof PersonHolderFieldsInput
          const errorMessage =
            apiErrorData &&
            apiErrorData.technical_director_address &&
            apiErrorData.technical_director_address[holderKey]
          const flattedMessage = [...(errorMessage || [])].join(' - ')
          setFieldError(
            `technical_director_address.${holderKey}`,
            flattedMessage
          )
        }
      )
    }

    // Errors for technical manager
    if (apiErrorData.technical_manager_address) {
      Object.keys(apiErrorData.technical_manager_address).forEach(
        (key: unknown) => {
          const holderKey = key as keyof PersonHolderFieldsInput
          const errorMessage =
            apiErrorData &&
            apiErrorData.technical_manager_address &&
            apiErrorData.technical_manager_address[holderKey]
          const flattedMessage = [...(errorMessage || [])].join(' - ')
          setFieldError(
            `technical_manager_address.${holderKey}`,
            flattedMessage
          )
        }
      )
    }

    // Errors for bank account 1
    if (apiErrorData.bank_account_1) {
      Object.keys(apiErrorData.bank_account_1).forEach((key: unknown) => {
        const bankKey = key as keyof BankAccountInput
        const errorMessage =
          apiErrorData &&
          apiErrorData.bank_account_1 &&
          apiErrorData.bank_account_1[bankKey]
        const flattedMessage = [...(errorMessage || [])].join(' - ')
        setFieldError(`bank_account_1.${bankKey}`, flattedMessage)
      })
    }

    // Errors for bank account 2
    if (apiErrorData.bank_account_2) {
      Object.keys(apiErrorData.bank_account_2).forEach((key: unknown) => {
        const bankKey = key as keyof BankAccountInput
        const errorMessage =
          apiErrorData &&
          apiErrorData.bank_account_2 &&
          apiErrorData.bank_account_2[bankKey]
        const flattedMessage = [...(errorMessage || [])].join(' - ')
        setFieldError(`bank_account_2.${bankKey}`, flattedMessage)
      })
    }
  }, [apiErrorData])

  return null
}
